var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGisPolygonDataShapefile3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "56px",
    viewBox: "0 0 31 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 1664.5836,
    y1: 15.8618,
    x2: 1727.4164,
    y2: 52.138199,
    gradientTransform: "matrix(0.484375,0,0,0.495283,-805.99999,-3.96227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(59.607843%,60.784314%,56.078431%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(22.352941%,27.058824%,4.705882%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(73.72549%,74.509804%,75.294118%)",
      fillOpacity: 1
    },
    d: "M 25.140625 27.734375 L 5.859375 27.734375 C 2.617188 27.734375 0 25.0625 0 21.742188 L 0 7.972656 C 0 4.65625 2.617188 1.980469 5.859375 1.980469 L 25.140625 1.980469 C 28.382812 1.980469 31 4.65625 31 7.972656 L 31 21.742188 C 31 25.0625 28.382812 27.734375 25.140625 27.734375 Z M 25.140625 27.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 25.140625 25.753906 L 5.859375 25.753906 C 2.617188 25.753906 0 23.082031 0 19.761719 L 0 5.992188 C 0 2.675781 2.617188 0 5.859375 0 L 25.140625 0 C 28.382812 0 31 2.675781 31 5.992188 L 31 19.761719 C 31 23.082031 28.382812 25.753906 25.140625 25.753906 Z M 25.140625 25.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.823529%,80%,75.686275%)",
      fillOpacity: 1
    },
    d: "M 24.023438 23.773438 L 6.976562 23.773438 C 4.214844 23.773438 1.9375 21.445312 1.9375 18.621094 L 1.9375 7.132812 C 1.9375 4.308594 4.214844 1.980469 6.976562 1.980469 L 24.023438 1.980469 C 26.785156 1.980469 29.0625 4.308594 29.0625 7.132812 L 29.0625 18.621094 C 29.0625 21.445312 26.785156 23.773438 24.023438 23.773438 Z M 24.023438 23.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.392157%,44.313725%,28.627451%)",
      fillOpacity: 1
    },
    d: "M 5.8125 3.960938 L 25.1875 3.960938 L 25.1875 21.792969 L 5.8125 21.792969 Z M 5.8125 3.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.039216%,60.784314%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 7.75 5.945312 L 23.25 5.945312 L 23.25 19.8125 L 7.75 19.8125 Z M 7.75 5.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.823529%,80%,75.686275%)",
      fillOpacity: 1
    },
    d: "M 23.25 6.933594 L 23.25 19.8125 L 7.75 19.8125 L 7.75 11.390625 L 10.171875 11.390625 L 12.109375 12.878906 L 17.4375 12.878906 Z M 23.25 6.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(40.392157%,44.313725%,28.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1678 29.99659 L 1686 29.99659 L 1690 34.003138 L 1698 34.003138 L 1698 42.00046 L 1702 45.99912 L 1702 49.997781 ",
    transform: "matrix(0.484375,0,0,0.495283,-805.99999,-3.96227)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.058333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(40.392157%,44.313725%,28.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 85.195834 137.721663 L 88.900001 134.017694 ",
    transform: "matrix(1.830709,0,0,1.871936,-139.500002,-244.927209)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.5625 7.925781 L 15.5 7.925781 L 15.5 9.90625 L 13.5625 9.90625 Z M 13.5625 7.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.375 13.867188 L 21.3125 13.867188 L 21.3125 15.847656 L 19.375 15.847656 Z M 19.375 13.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.6875 15.847656 L 11.625 15.847656 L 11.625 17.832031 L 9.6875 17.832031 Z M 9.6875 15.847656 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGisPolygonDataShapefile3);
export default __webpack_public_path__ + "static/media/GIS_Polygon_Data_Shapefile3.ea336e537a0ed768d4b4f3c26eaf20b3.svg";
export { ForwardRef as ReactComponent };